import { DEFAULT_FONT } from "src/constants";
import WebFont from "webfontloader";

export async function loadFontFamily(context: any, font: string = DEFAULT_FONT) {
    const fontTmp = font.toLowerCase();

    switch (fontTmp) {
        case "lexus":
            WebFont.load({
                custom: {
                    families: ["Nobel:n4,n5,n7"],
                    urls: ["/fonts/lexus/lexus.css"],
                },
                context: context?.frameElement?.contentWindow,
            });

            return "Nobel";

        default:
            WebFont.load({
                google: {
                    families: ["Roboto:300,400,500,700", "Roboto-Bold"],
                },
                context: context?.frameElement?.contentWindow,
            });

            return DEFAULT_FONT;
    }
}
